import "core-js/modules/es.object.keys.js";
import { handleHoverColorEnter, handleHoverColorLeave } from "@/pages/design/common/utils";
import { designNews } from '@/services/design';
/**
 * 发布状态
 * @enum
 */
var PublishStatus = {
  /** 未发布 */
  NO_PUBLISHED: 0,
  /** 已发布 */
  PUBLISHED: 1
};
export default {
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      defaultLangId: 0,
      news: []
    };
  },
  created: function created() {
    var defaultLangObjStr = window.localStorage.cdefaultLangObj ? window.localStorage.cdefaultLangObj : window.localStorage.defaultLangObj;
    var defaultLangObj = JSON.parse(defaultLangObjStr);
    // let defaultLangObj = JSON.parse(localStorage.defaultLangObj)
    if (defaultLangObj) {
      this.defaultLangId = defaultLangObj.langId;
    }
    this.getData();
  },
  methods: {
    /**
     * 获取新闻发布时间中的发布日期
     * @param publishTime 发布时间
     * @returns {string} 发布日期
     */
    getPublishDate: function getPublishDate(publishTime) {
      var publishDate = '';
      if (publishTime && _.isString(publishTime)) {
        publishDate = publishTime.split(' ')[0];
      } else {
        publishDate = '';
      }
      return publishDate || '';
    },
    handleHoverColorEnter: handleHoverColorEnter,
    handleHoverColorLeave: handleHoverColorLeave,
    getData: function getData() {
      var _this = this;
      designNews({
        page: 1,
        size: 9,
        langId: this.defaultLangId,
        clientType: 2,
        orderType: 1,
        orderWay: 2,
        publishStatus: 1
      }).then(function (res) {
        return res.data;
      }).then(function (res) {
        if (res.code === 200) {
          var list = res.data.list;
          if (_.isArray(list)) {
            _this.news = list;
          } else {
            _this.news = [];
          }
        }
      });
    }
  }
};